module.exports = __webpack_public_path__ + "static/media/empathy-map.a667039c.svg";